import * as React from "react";
import type { SVGProps } from "react";
const SvgSuitcaseWithCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8 18.03 8-.02v-4.02c0-.33.2-.99 1-.99s1 .657 1 .985v4.02L20 18V8.96c0-.32.2-.96 1-.96s1 .64 1 .96v9.08a1.963 1.963 0 0 1-1.89 1.959V20c0 .55-.45 1-1 1s-1-.45-1-1H5.89c0 .55-.45 1-1 1s-1-.45-1-1v-.001A1.963 1.963 0 0 1 2 18.04V7.96C2 6.88 2.88 6 3.96 6H8V4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2c0 1.5-.5 1.987-2 1.987H9.16a.997.997 0 0 1-.316 0L8 7.99v10.04ZM3.96 8 4 18.04l2-.005V7.995L3.96 8ZM10 6h4V5h-4v1Zm2.689 10h.01c.33 0 .63-.16.82-.43l7-10c.31-.45.2-1.08-.25-1.39-.45-.31-1.07-.2-1.39.25l-6.15 8.79-1.19-1.78c-.31-.46-.93-.59-1.39-.28-.46.31-.59.93-.28 1.39l2 3c.18.28.49.45.82.45Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSuitcaseWithCheckMark;
